import http from "../utils/http";
import { toast } from "../utils/toast";

// 경비청구 (지출항목) 내역 목록 조회
export const getExpenseList = (body) => {
  //console.log('body: ', body)
  return new Promise((resolve, reject) => {
    http
      .post("/expenses/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//  경비청구 (지출항목) 내역 목록 조회 - 엑셀다운로드
export const getExpenseDownloadExcel = (body) => {
  //console.log('body: ', body)
  return new Promise((resolve, reject) => {
    http
      .post("/expenses/excel", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 경비청구 (지출항목) 단일 내역 조회
export const getExpenseDetail = (dataIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/expenses/${dataIdx}/detail`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 경비청구 (지출항목) 내역 등록
export const createExpense = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/expenses", body)
      .then((res) => {
        toast.success("경비청구 요청이 완료되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 경비청구 (지출항목) 옵션
export const getExpenseOptionsList = () => {
  return new Promise((resolve, reject) => {
    http
      .post('/expense-options/list')
      .then((res) => {
        resolve(res.data.options);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createExpenseOption = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/expense-options", body)
      .then((res) => {
        toast.success("비용항목 등록이 완료되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const modifyExpenseOptionOrder = (body) => {
  return new Promise((resolve, reject) => {
    http
      .put("/expense-options/order", body)
      .then((res) => {
        toast.success("비용항목 저장 되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const deleteExpenseOption = (dataIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/expense-options/${dataIdx}`)
      .then((res) => {
        toast.success("비용항목 삭제 되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};